import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { UserReport, UserRoles, UserSchema, UserService } from 'src/app/core';
import { DiscountService } from 'src/app/feature/services';
import { Discount } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './admin-user-preview.component.html',
  styleUrls: ['./admin-user-preview.component.sass'],
})
export class AdminUserPreviewComponent implements OnInit {
  public userReport!: UserReport;
  public protectedUserReport!: UserReport;
  public userDiscounts!: Discount[];
  public userRoles = UserRoles;

  public user?: UserSchema;
  private subsink = new SubSink();

  constructor(
    activatedRoute: ActivatedRoute,
    private discountService: DiscountService,
    private userService: UserService,
    private snackbar: MatSnackBar
  ) {
    activatedRoute.data.subscribe((data) => {
      this.userReport = structuredClone(data['userReport']);
      this.protectedUserReport = structuredClone(data['userReport']);
    });
  }
  ngOnInit(): void {
    this.subsink.sink = this.discountService
      .getDiscountPackagesForUser(this.userReport.user_id)
      .subscribe((data) => {
        this.userDiscounts = data;
      });
    this.subsink.sink = this.userService
      .getAdminUserScoresById(this.userReport.user_id)
      .subscribe((res) => {
        console.log(res);
      });
  }

  changeUserActivation(event: MatSlideToggleChange) {
    this.userService.changeUserActivation(this.userReport.user_id).subscribe({
      next: (response) => {
        let status = event.checked === true ? 'فعال' : 'غیرفعال';
        this.snackbar.open(`وضعیت کاربر با موفقیت ${status} شد.`, 'باشه', {
          duration: 1500,
        });
      },
      error: (error) => {
        setTimeout(() => {
          this.userReport = structuredClone(this.protectedUserReport);
        }, 100);
        this.snackbar.open('خطا در به‌روز رسانی وضعیت کاربر', 'باشه', {
          duration: 1500,
        });
      },
    });
  }

  changeRole(userRole: UserRoles) {
    this.userService.changeUserRole(this.userReport.user_id, userRole).subscribe({
      next: (response) => {
        this.snackbar.open('تغییر نقش کاربر با موفقیت انجام شد.', 'باشه', {
          duration: 1500,
        });
        this.userService.getUserReport(this.userReport.user_id).subscribe(res => {
          this.userReport = res;
        })
      },
      error: (error) => {
        setTimeout(() => {
          this.userReport = structuredClone(this.protectedUserReport);
        }, 100);
        this.snackbar.open('خطا در به‌روز رسانی نقش کاربر', 'باشه', {
          duration: 1500,
        });
      },
    });

  }
}
